import { Receipt, Users, Bot, Workflow, Server, LayoutGrid, Cable, Wrench, Gauge, Sparkles } from "lucide-react";

// Map string icon keys stored in the DB to lucide components.
export const ICON_MAP = {
  Receipt, Users, Bot, Workflow, Server, LayoutGrid, Cable, Wrench, Gauge, Sparkles,
};

export const getIcon = (key) => ICON_MAP[key] || Sparkles;
